var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatus(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1.455c0 .8-.655 1.454-1.455 1.454a1.236 1.236 0 0 1-.37-.05l-2.59 2.581a1.459 1.459 0 0 1-1.404 1.833A1.459 1.459 0 0 1 8.779 5.44L6.924 3.585c-.117.037-.248.051-.379.051-.13 0-.261-.014-.378-.05L2.858 6.901c.037.116.051.24.051.37 0 .8-.654 1.455-1.454 1.455C.655 8.727 0 8.073 0 7.273c0-.8.655-1.455 1.455-1.455.13 0 .254.015.37.051L5.142 2.56A1.459 1.459 0 0 1 6.546.727 1.459 1.459 0 0 1 7.948 2.56l1.855 1.855c.116-.037.247-.051.378-.051.13 0 .262.014.378.05l2.582-2.589a1.236 1.236 0 0 1-.051-.37c0-.8.654-1.455 1.454-1.455.8 0 1.455.655 1.455 1.455Z",
    fill: "#90A9C0",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus);
export default __webpack_public_path__ + "static/media/status.5ee0c621d149b5e3f319df9599297e2e.svg";
export { ForwardRef as ReactComponent };